import React, { useState, useEffect } from 'react';
import {
  HiOutlineSpeakerphone,
  HiOutlineUserCircle,
  HiOutlineX,
  HiOutlineChevronRight,
  HiOutlineCog,
} from 'react-icons/hi';
import { PiGridFour } from 'react-icons/pi';
import { TfiReload } from 'react-icons/tfi';
import { LiaFileContractSolid } from 'react-icons/lia';
import AppLogo from '../../assets/images/Header.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import circle2 from '../../assets/icons/Vector (7).svg';
import allrequest from '../../assets/icons/allrequest.svg';
import contract from '../../assets/icons/file-paper-2-line.svg';
import announcement from '../../assets/icons/announcement.svg';
import setting from '../../assets/icons/setting.svg';
import headphone from '../../assets/icons/headphone-line.svg';
import { FaMapMarkedAlt, FaPrescription } from 'react-icons/fa';
import { GrCluster } from 'react-icons/gr';
import { RiHospitalFill } from 'react-icons/ri';
import { FaStethoscope } from 'react-icons/fa6';

const Sidebar = ({ isCollapsed, isRtl }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSettingsExpanded, setSettingsExpanded] = useState(false);
  const [activeItem, setActiveItem] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const CircleIcon = () => <img src={circle2} alt="logo" />;
  const AllRequest = () => <img src={allrequest} alt="logo" />;
  const Contract = () => <img src={contract} alt="logo" />;
  const Announcement = () => <img src={announcement} alt="logo" />;
  const Setting = () => <img src={setting} alt="logo" />;
  const headPhone = () => <img src={headphone} alt="logo" />;

  const routes = [
    {
      path: '/dashbaord',
      label: 'Dasboard',
      icon: PiGridFour,
      excludedRoles: [],
    },
    {
      path: '/practitioners',
      label: 'Practitioners',
      icon: HiOutlineSpeakerphone,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/my-profile',
      label: 'My Profile',
      icon: HiOutlineUserCircle,
      excludedRoles: [
        'MoH Manager',
        'moh_manager',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/All Request', // New route path for hospital_manager
      label: 'All Requests', // Label for the route
      icon: AllRequest, // Choose an appropriate icon
      excludedRoles: ['physician_management'], // No exclusion for this route, will be visible only for hospital_manager
      rolesAllowed: [
        'MoH Manager',
        'moh_manager',
        'hospital_manager',
        'cluster_manager',
      ], // Only visible to users with the hospital_manager role
    },
    {
      path: '/Announcement',
      label: 'Announcements',
      icon: Announcement,
      excludedRoles: [],
    },
    {
      path: '/Contracts',
      label: 'Contracts',
      icon: Contract,
      excludedRoles: [],
    },
    // {
    //   path: "/Cluster", // New route path for hospital_manager
    //   label: "All Requests", // Label for the route
    //   icon: TfiReload, // Choose an appropriate icon
    //   excludedRoles: [
    //     "MoH Manager",
    //     "moh_manager",
    //     "physician_management",
    //     "hospital_manager",
    //   ], // No exclusion for this route, will be visible only for hospital_manager
    //   rolesAllowed: ["cluster_manager"], // Only visible to users with the hospital_manager role
    // },
  ];

  const bottomRoutes = [
    {
      path: '/settings',
      label: 'Settings',
      icon: Setting,
      excludedRoles: [
        'guest',
        'hospital_manager',
        'cluster_manager',
        'physician_management',
      ],
      isExpandable: true,
    },
    {
      label: 'Support',
      icon: headPhone,
      excludedRoles: [],
    },
  ];

  const settingsSubRoutes = [
    {
      path: '/users',
      label: 'Users',
      icon: HiOutlineUserCircle,
      excludedRoles: [
        'guest',
        'user',
        'manager',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/add-region',
      label: 'Regions',
      icon: FaMapMarkedAlt,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/add-cluster',
      label: 'Clusters',
      icon: GrCluster,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },

    {
      path: '/add-hospital',
      label: 'Hospitals',
      icon: RiHospitalFill,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/specialties',
      label: 'Specialties',
      icon: FaStethoscope,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },
    {
      path: '/med-specialties',
      label: 'Medical Specialties',
      icon: FaPrescription,
      excludedRoles: [
        'physician_management',
        'hospital_manager',
        'cluster_manager',
      ],
    },
  ];

  useEffect(() => {
    const allRoutes = [...routes, ...bottomRoutes, ...settingsSubRoutes];

    let d = location.pathname.replace(/%20/g, '');
    if (d === '/AllRequest') {
      d = '/All Request';
    }

    const activeRoute = allRoutes.find((route) => route.path === d);
    setActiveItem(activeRoute ? activeRoute.path : '');
  }, [location.pathname]);

  const handleSettingsClick = () => setSettingsExpanded(!isSettingsExpanded);

  const filteredRoutes = routes.filter(
    (route) => !route.excludedRoles.includes(user?.role)
  );

  const filteredBottomRoutes = bottomRoutes.filter(
    (route) => !route.excludedRoles.includes(user?.role)
  );

  const filteredSettingsSubRoutes = settingsSubRoutes.filter(
    (route) => !route.excludedRoles.includes(user?.role)
  );

  return (
    <div
      className={`fixed top-0 bottom-0 left-0 z-10 bg-white h-full border-r border-[#E2E4E9] flex flex-col text-white transition-all duration-300 w-[15%]`}
    >
      <div className="flex justify-center p-4">
        <img src={AppLogo} alt="App Logo" className="w-100 h-10" />
      </div>

      <div className="w-full flex items-center justify-center ">
        <div className="bg-[#E2E4E9] h-[1px] rounded-full w-[85%]  box-border"></div>
      </div>

      <nav className="flex-1 mt-4">
        <ul className="flex flex-col gap-[6px] pl-0">
          {filteredRoutes.map((route) => (
            <li
              key={route.path}
              className="w-full px-4 py-[2px] relative"
              onClick={() => {
                navigate(route.path);
                localStorage.setItem('title', '');
              }}
            >
              <div
                className={`flex items-center gap-[8px] p-2.5 cursor-pointer ${
                  activeItem === route.path
                    ? "bg-menu-item-bg font-semibold font-inter bg-[#F6F8FA] rounded-lg before:content-[''] before:w-1 before:h-5 before:rounded-tr-md before:rounded-br-md before:bg-[#2D9F75] before:absolute before:left-0"
                    : ''
                }`}
              >
                <route.icon className="text-[#2D9F75] h-[20px] w-[20px] " />
                {!isCollapsed && (
                  <span className="text-black">{route.label}</span>
                )}
              </div>
            </li>
          ))}
        </ul>
      </nav>

      <div className="mt-auto">
        <ul className="space-y-2 pl-0">
          {filteredBottomRoutes.map((route) => (
            <li
              key={route.path}
              className="w-full px-4 relative"
              onClick={
                route.path === '/settings'
                  ? handleSettingsClick
                  : () => navigate(route.path)
              }
            >
              {activeItem === route.path && (
                <div className="absolute w-2 h-8 rounded-tr-md rounded-br-md bg-[#2D9F75] left-0"></div>
              )}
              <div
                className={`flex items-center space-x-5 h-8 cursor-pointer ${
                  activeItem === route.path ? 'bg-menu-item-bg' : ''
                }`}
              >
                <route.icon
                  size={24}
                  className="text-[#525866] flex-shrink-0"
                />
                {!isCollapsed && (
                  <span className="text-black flex-grow ml-5">
                    {route.label}
                  </span>
                )}
                {route.path === '/settings' && !isCollapsed && (
                  <HiOutlineChevronRight
                    size={18}
                    className="text-[#525866] flex-shrink-0 ml-auto"
                  />
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
      <h3 className="text-[#CDD0D5] pb-8 font-[Sofia_Pro] font-normal text-xs m-0 w-full text-center">
        Powered by Ascend Solutions
      </h3>
      <div
        className={`
          fixed top-0 bottom-0 ${
            isRtl ? 'right-0' : 'left-0'
          } z-10 bg-white h-full border-r border-[#E2E4E9] flex flex-col text-white transition-all duration-300
          
          
          ${
            isSettingsExpanded ? 'w-[15%]' : 'w-0'
          } h-full bg-white transition-all duration-300 overflow-hidden`}
      >
        <button
          className="absolute top-4 right-4 text-white"
          onClick={handleSettingsClick}
        >
          <HiOutlineX size={24} className="text-black" />
        </button>
        {isSettingsExpanded && (
          <nav className="flex-1">
            <ul className="space-y-2 mt-16 pl-0">
              {filteredSettingsSubRoutes.map((route) => (
                <li
                  key={route.path}
                  className="w-full px-4 relative"
                  onClick={() => navigate(route.path)}
                >
                  {activeItem === route.path && (
                    <div className="absolute w-2 h-8 rounded-tr-md rounded-br-md bg-[#2D9F75] left-0"></div>
                  )}
                  <div
                    className={`flex items-center space-x-5 h-8 cursor-pointer ${
                      activeItem === route.path ? 'bg-menu-item-bg' : ''
                    }`}
                  >
                    <route.icon size={24} className="text-[#2D9F75]" />
                    {!isCollapsed && (
                      <span className="text-black">{route.label}</span>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
